import { useSearch } from '@/react/portainer/gitops/queries/useSearch';

import { EffectiveGitReference } from './useResolvedGitConfig';

export interface UseGitFileCheckParams {
  config: Pick<EffectiveGitReference, 'configFilePath' | 'sourceId' | 'ref'>;
  enabled: boolean;
  isConfigLoading: boolean;
  blockedByPriorErrors: boolean;
}

export function useGitFileCheck({
  enabled,
  config: { configFilePath, ref, sourceId },
  isConfigLoading,
  blockedByPriorErrors,
}: UseGitFileCheckParams) {
  const query = useSearch(
    { keyword: configFilePath || '', reference: ref, sourceId },
    {
      enabled:
        enabled &&
        !!sourceId &&
        !!ref &&
        !!configFilePath &&
        !blockedByPriorErrors,
    }
  );

  const found =
    !!configFilePath && !!query.data && query.data.includes(configFilePath);

  const hasFileError =
    enabled &&
    !isConfigLoading &&
    (!configFilePath || query.isError || (query.isFetched && !found));

  const error = hasFileError ? { rawError: query.error } : undefined;

  return {
    found,
    isLoading: enabled && (isConfigLoading || query.isFetching),
    error,
  };
}
